// Auth Actions Types 

export const UPDATE_CHANGES = 'UPDATE_CHANGES'
export const UPDATE_ADMIN_ROLE = 'UPDATE_ADMIN_ROLE'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const CLEAR_CART = 'CLEAR_CART'
export const UPDATE_CART_FIREBASE = 'UPDATE_CART_FIREBASE'